import { useState, useEffect } from 'react';


export default function useIsChartCoverageDemo() {
    const isDemo = new URLSearchParams(window.location.search).has("isChartCoverageDemo");
    return isDemo;
}
